import React, { createElement, memo, useMemo } from 'react';
import imageApi from '@umu/umu-image-handle';

interface IProps {
    children: React.ReactElement;
    option?: imageApi.IProcessOptions;
}

/**
 * 基于 PreImg 修改的对 src 有缓存的组件
 */
export const MemoPreImg = memo((props: IProps) => {
    const { children, option = {} } = props;

    const element = useMemo(() => {
        const childProps = { ...children.props };
        if (typeof children.props.src === 'string') {
            childProps.src = imageApi.process(children.props.src, option);
        }
        return createElement('img', childProps);
    }, [children.props?.src]);

    if (!children || children.type !== 'img') {
        return children;
    }

    return element;
});
